module.exports = __webpack_public_path__ + "img/228_btn1.978de024.png";